// extracted by mini-css-extract-plugin
export default {"list-item":"lsf-list-item","list-item__title":"lsf-list-item__title","list-item__counter":"lsf-list-item__counter","list-item__visibility":"lsf-list-item__visibility"};
    if(module.hot) {
      // 1637785525842
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  